import { createAsyncThunk } from '@reduxjs/toolkit';
import callApi from '../../utils/api/callAPI';

/**
 * Gọi API lấy danh sách texture
 * @param {Object} values Tham số truyền vào
 * @param {number} values.offset Vị trí bắt đầu lấy dữ liệu
 * @param {number} values.limit Số lượng dữ liệu lấy về
 * @param {string} values.supplier Nhà cung cấp
 * @param {string} values.priceCollectionTypes Nhà cung cấp
 * @param {string} values.code Mã texture
 */
export const fetchCampaigns = createAsyncThunk(
  'get/sale_products/v3/list_campaigns',
  async (_, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'sale_products/v3/list_campaigns',
        method: 'get',
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { data, total: response.count };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      throw error;
    }
  },
  {
    condition: (arg, { getState }) => {
      const { texture: state } = getState();

      // Chặn request nếu đang loading
      if (JSON.stringify(state.textures.preParams) === JSON.stringify(arg)) {
        return false;
      }
      return true;
    },
  }
);
